import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { NotificationBannerModel as Model } from './Model'


export const MODULE_NAME = 'notification-banners'

export const NOTIFICATION_BANNERS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: NOTIFICATION_BANNERS_ROUTES.LAYOUT,
  route: { name: NOTIFICATION_BANNERS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-newspaper-variant-outline',
} as const

export const createNotificationBannersPublicationSelectModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "NotificationBannersPublicationSelect" */
    './components/NotificationBannersPublicationSelect.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
